import db from "../db/database";
import { fetchFromBusinessCentral } from "../utils/businessCentralUtils";
import { isOnline } from "./syncService";
import { anotarError } from "./syncLog";

export const syncFormasDePago = async () => {
  if (!isOnline()) {
    return false;
  }

  try {
    // Obtener formas de pago del servidor
    const serverFormasDePago = await fetchFromBusinessCentral("FormasPago", "Tpv eq true");

    // Borrar todas las formas de pago locales
    await db.formasPago.clear();

    // Añadir las formas de pago del servidor
    for (const serverFormaPago of serverFormasDePago) {
      await db.formasPago.add({
        No: serverFormaPago.No,
        Code: serverFormaPago.Code || serverFormaPago.CodFormaPago,
        Description: serverFormaPago.Description || serverFormaPago.Descripcion,
        Dto: serverFormaPago.Dto || 0,
        Tipo_Pago: (serverFormaPago.Tipo_Pago || "").trim() || "Efectivo",
        lastSynced: new Date(),
      });
    }

    return true;
  } catch (error) {
    anotarError("formas de pago", "falló la lectura", error);
    return false;
  }
};
